import { postFetch } from '@legacy/utils/fetcher';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { GET_TIME_TRACKER_KEY } from '../utils';

export const useStopTimeTracker = (
  setIsStopButtonDisabled: React.Dispatch<React.SetStateAction<boolean>>,
  stopPath?: string,
) => {
  const stopTimerPost = () => {
    if (stopPath) {
      return postFetch({ path: stopPath, key: 'stopTimeTrackerPath' });
    }
    return postFetch({ path: '', key: '' });
  };
  const qc = useQueryClient();

  return useMutation({
    mutationFn: stopTimerPost,

    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [GET_TIME_TRACKER_KEY],
      });
      setIsStopButtonDisabled(false);
      if (
        window.location.pathname === '/Registration/TimeTracking' ||
        window.location.pathname === '/Registration/TimeTracking/Index'
      )
        window.location.reload();
    },

    onMutate: () => {
      setIsStopButtonDisabled(true);
    },

    onError: () => {
      setIsStopButtonDisabled(false);
    },
  });
};
